require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./effective-case-management-with-domestic-violence-offenders.json") })
        }
      }, "path---effective-case-management-with-domestic-violence-offenders");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---effective-case-management-with-domestic-violence-offenders!./.cache/json/effective-case-management-with-domestic-violence-offenders.json
// module id = 888
// module chunks = 231608221292675